export default __webpack_public_path__ + "static/media/ig.678ceb50.svg";